module.exports = __webpack_public_path__ + "img/tryher-card-compare.7f2a8027.png";